import { Flex } from "@chakra-ui/layout";
import { useFormikContext } from "formik";
import React from "react";
import { EligibleFilterType } from "src/schemas/formTemplateFilters";
import * as AF from "src/types/formTemplate";
import * as RD from "src/types/remoteData";
import { z } from "zod";
import { QuestionVisibility } from "../../QuestionVisibility";
import * as ConfigureLocationBoundaries from "../QuestionConfiguration/ConfigureLocationBoundaries";
import { ConfigureQuestion } from "../QuestionConfiguration/ConfigureQuestion";
import {
  ConfigureQuestionMenu,
  ConfigureQuestionMenuTabs,
} from "../QuestionConfiguration/ConfigureQuestionMenu";
import { SchoolItem } from "../types";
import { PermissionLevel } from "./PermissionLevel";
import { QuestionLink } from "./QuestionLink";

export const FormikSchema = ConfigureLocationBoundaries.FormikSchema;
export type FormikType = z.infer<typeof FormikSchema>;

export type AddressQuestionFormProps = {
  schools: RD.RemoteData<unknown, SchoolItem[]>;
  questionId: uuid;
  sectionType: AF.V2.SectionType;
  otherQuestions: readonly AF.V2.Question[];
};
export function AddressQuestionForm({
  questionId,
  otherQuestions,
  schools,
  sectionType,
}: AddressQuestionFormProps) {
  const [configureQuestionTab, setConfigureQuestionTab] =
    React.useState<ConfigureQuestionMenuTabs>(
      ConfigureQuestionMenuTabs.ConfigureQuestion
    );

  const formik = useFormikContext<FormikType>();

  const handleConfigureMenuChange = (newTab: ConfigureQuestionMenuTabs) => {
    setConfigureQuestionTab(newTab);
  };

  // const filters = formik.values.filters;

  const alreadyHasLocationBoundariesFilter = otherQuestions.some(
    (otherQuestion) =>
      (otherQuestion.filters?.filter(
        (f) => f.type === EligibleFilterType.LocationBoundariesFilter
      ).length ?? 0) > 0
  );

  return (
    <>
      <Flex direction="row" gap="4">
        <ConfigureQuestionMenu
          activeTab={configureQuestionTab}
          onMenuChange={handleConfigureMenuChange}
          items={[
            { type: "Separator", label: "Limit available options" },
            {
              type: ConfigureQuestionMenuTabs.LocationBoundaries,
              label: "Location Boundaries",
              status:
                formik.values.locationBoundaries.switch === "on" ? "on" : "off",
            },
          ]}
        />
        {configureQuestionTab ===
          ConfigureQuestionMenuTabs.ConfigureQuestion && (
          <ConfigureQuestion questionId={questionId} />
        )}
        {configureQuestionTab ===
          ConfigureQuestionMenuTabs.LocationBoundaries && (
          <ConfigureLocationBoundaries.ConfigureLocationBoundaries
            questionId={questionId}
            disabled={alreadyHasLocationBoundariesFilter}
          />
        )}
      </Flex>
      {configureQuestionTab === ConfigureQuestionMenuTabs.ConfigureQuestion && (
        <Flex direction="column" flexGrow="1" gap="3">
          <QuestionLink questionId={questionId} />
          <PermissionLevel questionId={questionId} />
          <QuestionVisibility
            sectionType={sectionType}
            otherQuestions={otherQuestions}
            schools={schools}
          />
        </Flex>
      )}
    </>
  );
}
